import React from 'react';
import EmojiPeopleRoundedIcon from '@mui/icons-material/EmojiPeopleRounded';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
import { ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import {
  MenuItem
} from 'react-pro-sidebar';
import CustomSubMenu from '../CustomSubMenu'; // Az újrafelosztott komponens

const EventStaffSubMenu = ({ location, collapsed, navigate }: { location: any; collapsed: boolean; navigate: any }) => {
  // Menu items (alapértelmezett lista)
  const menuItems = [
    <MenuItem
      key="scheduler"
      icon={<CalendarMonthRoundedIcon />}
      onClick={(event: any) => {
        if (event.metaKey || event.ctrlKey) {
          window.open(`/admin/scheduler`, '_blank');
        } else {
          navigate(`/admin/scheduler`);
        }
      }}
    >
      Scheduler
    </MenuItem>,
  ];

  // Popper items (összehúzott nézet esetén)
  const popperItems = [
    <ListItemButton
      key="scheduler"
      onClick={(event: any) => {
        if (event.metaKey || event.ctrlKey) {
          window.open(`/admin/scheduler`, '_blank');
        } else {
          navigate(`/admin/scheduler`);
        }
      }}
    >
      <ListItemIcon>
        <EmojiPeopleRoundedIcon />
      </ListItemIcon>
      <ListItemText primary="Event Staff" />
    </ListItemButton>,
  ];

  return (
    <CustomSubMenu
      props={{
        location: location,
        collapsed: collapsed,
        label: 'Event Staff',
        icon: <EmojiPeopleRoundedIcon />,
        items: menuItems,
        popperItems: popperItems,
      }}
    />
  );
};

export default EventStaffSubMenu;
